'use client';

import { useCurrentUser } from '@/contexts/authentication/client';
import { useBalance } from './useBalance';

/**
 * @deprecated Use useBalance(familyId) directly.
 * Shim that auto-resolves familyId from the current user session.
 */
export function useTokenBalance() {
  const { user } = useCurrentUser();
  return useBalance(user?.familyId);
}
